var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("iframe", {
    staticClass: "w-100",
    attrs: { src: "../../../../../public/csv/Category.csv", height: "400" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }